export default __webpack_public_path__ + "static/media/img5.06d428f3.png";